import {
    serializable,
    DynamicFormControlLayout,
    DynamicInputModel,
    DynamicInputModelConfig
} from "@ng-dynamic-forms/core";
import { Model_WorkflowComponent, CODE_WORKFLOW_COMPONENT, TYPE_DATASOURCE } from 'src/app/app.models';
import { COMPONENT_MODE, COMPONENT_UI, ComponentDatasourceProvider } from '../workflow-components.models';
import { WorkflowComponentBuilderOptions } from '../workflow-components.service';
import { ABW_MAT_DATATABLE_VIEWMODE } from '../../abw-mat-datatable/abw-mat-datatable.component';
  
export interface DatasourceDatasSelectionModelConfig extends DynamicInputModelConfig {
	componentMode: COMPONENT_MODE;
    datas: any;
}
  
export class DatasourceDatasSelectionModel extends DynamicInputModel {
	@serializable() readonly type: string = 'datasource_datas_selection'; 
	componentMode: COMPONENT_MODE;
	componentUI: COMPONENT_UI;
    datas: any;

	constructor(config: DatasourceDatasSelectionModelConfig, layout?: DynamicFormControlLayout) {
		super(config, layout);
		this.componentMode = config.componentMode;
		this.componentUI = COMPONENT_UI.IONIC;
		this.datas = config.datas;
	}

	static initModel(_component: Model_WorkflowComponent, _datasource: ComponentDatasourceProvider): DatasourceDatasSelectionModel {
		const formModel = new DatasourceDatasSelectionModel({
			id: _component.ID,
			name: _component.ID,
			label: _component.LABEL,
            datas: { 
				mPagination: {
					mDatas: _datasource.DATASOURCE_FILTERED_DATAS, 
					mCountTotal: _datasource.DATASOURCE_COUNT_TOTAL, 
					mPageNumber: _datasource.DATASOURCE_PAGE_NUMBER, 
					mTotalPages: _datasource.DATASOURCE_TOTAL_PAGES, 
					mPageSize: _datasource.DATASOURCE_PAGE_SIZE,
				},
				mAbsColumns: _datasource.DATASOURCE_COLUMNS,
			},
			value: _component.DEFAULT_VALUE,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE !== undefined ? _component.IS_VISIBLE === false : false,
			validators: _component.CUSTOM_VALIDATORS,
			componentMode: _component.COMPONENT_MODE,
			additional: _component,
			relations: _component.RELATIONS
		});
		return formModel;
	}

	static getProperties(_options?: WorkflowComponentBuilderOptions): Model_WorkflowComponent {
		return {
			ID: 'datasource_datas_selection',
			CODE: CODE_WORKFLOW_COMPONENT.DATASOURCE_DATAS_SELECTION,
			ICON: 'server-outline',
			LABEL: 'Sélection Datasource',
			HAS_DATASOURCE: true,
			PROPERTIES: [
				{ ID: 'GUID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'GUID', IS_VISIBLE: false },
				{ ID: 'INDEX', CODE: CODE_WORKFLOW_COMPONENT.NUMERIC_TEXTBOX, LABEL: 'Index', DEFAULT_VALUE: 1 },
				{ ID: 'ID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Identifiant', IS_REQUIRED: true, DEFAULT_VALUE: "OPEN_DATASOURCE", CUSTOM_VALIDATORS: [{ VALIDATOR_NAME: 'no_whitespace' }] },
				{ ID: 'LABEL', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Libellé', IS_REQUIRED: true, DEFAULT_VALUE: "Ouvrir source de données" },
				{ ID: 'NUM_DATASOURCE', CODE: CODE_WORKFLOW_COMPONENT.DATASOURCE_PICKER, LABEL: 'Source de données', IS_REQUIRED: true },
			]
		};
	}
}
  